import { CoachInfoSectionProps } from "../CoachInfo";
import { DETAILS_SECTIONS, DetailsSection } from "../DetailsSections";

export default function CoachInfoDetails({
    inSeeMore,
    ...sectionProps
}: CoachInfoSectionProps & { inSeeMore: boolean }) {
    const sectionsToShow = Object.entries(DETAILS_SECTIONS)
        .filter(
            ([section]) =>
                sectionProps.config.sectionsToShowOutsideOfSeeMore.includes(
                    section as DetailsSection,
                ) !== inSeeMore,
        )
        .map(([section, Component]) => (
            <Component key={section} {...sectionProps} />
        ));
    return (
        <div className="flex flex-col gap-6 mt-4 self-stretch text-brand-black">
            {sectionsToShow}
        </div>
    );
}
